import React from "react";

import classNames from "classnames";

import "./spinner.scss";

interface SpinnerProps {
  size?: "lg" | "xl" | "ul" | "xxl";
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = undefined,
  className = undefined,
}) => (
  <span
    className={classNames(
      "spinner",
      className,
      { [`spinner--${size}`]: size },
    )}
  />
);

export default Spinner;
